import * as React from 'react';
import { connect } from 'react-redux';
import { format } from "../utils/format";

import Indication from '../ui/indication.js';
import Icon from '../icon/icon.js';

import AddCardBtn from './add-new-card.block.js';
import { addCard, deleteCard } from './card.actions.js';

import { cardsSelector, cardsListSelector } from './card.selectors';
import { payerSelector, userSelector } from '../user/user.selectors.js';

import { ADD_CARD } from './card.const.js';

import { selectUIModal, selectUIMessages, selectUIProgress } from '../ui/ui.helpers.js';
import { setModal } from '../ui/ui.actions.js';

import type { Messages } from '../ui/ui.types.js';

type OwnProps = {||};

type MappedState = {|
  messages: Messages,
  progress: boolean,
  addCardModal: boolean,
  cards: $ElementType<ReduxState, 'cards'>,
  cardsList: List,
  user: $ElementType<ReduxState, 'user'>,
  payer: $ElementType<ReduxState, 'payer'>
|};

type Props = {|
  ...OwnProps,
  ...MappedState,
  addCard: typeof addCard,
  deleteCard: typeof deleteCard,
  setModal: typeof setModal,
  children: React.Node
|};

class CardScreen extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.onAddCardOpen = this.onAddCardToggle.bind(this, true);
    this.onAddCardClose = this.onAddCardToggle.bind(this, false);

    this.onAddCard = this.onAddCard.bind(this);
    this.onDeleteCard = this.onDeleteCard.bind(this);
  }

  onAddCardOpen: Function;
  onAddCardClose: Function;

  onAddCardToggle(state: boolean) {
    this.props.setModal(state, ADD_CARD);
    return true;
  }


  onAddCard(stripe) {
    return this.props.addCard(stripe);
  }

  onDeleteCard(e) {
    return this.props.deleteCard(e.currentTarget.dataset.id);
  }

  render() {
    const { messages, progress, cards, cardsList, children } = this.props;

    return (
      <div>
        <Indication closable messages={messages} className="message-indicator" />

        <div>
          <div className="cards-block">
            <div className="heading-block">
              <div className="heading-block-name">
                <Icon width="12px" height="14px" name="card" className="icon-primary" />
                <span className="heading-text">Billing Information</span>
              </div>

              <AddCardBtn />
            </div>
            <div className="cards-list-wrap">
              {cardsList.length ? (
                <div>
                  {cardsList.map(id => (
                    <div className="cards-list-item" key={`card-${id}`}>
                      <span>
                        {cards[id].brand} ending in {cards[id].last4}, exp.{' '}
                        {format(cards[id].expirationDateTime, 'm/y')}
                      </span>
                      <button
                        onClick={this.onDeleteCard}
                        disabled={progress}
                        data-id={id}
                        className="remove-cards-list-item"
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                </div>
              ) : (
                <div>There aren't any Cards yet.</div>
              )}
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const messagesSelector = selectUIMessages();
const progressSelector = selectUIProgress(ADD_CARD);
const addCardModalSelector = selectUIModal(ADD_CARD);

const mapStateToProps = state => ({
  messages: messagesSelector(state),
  progress: progressSelector(state),
  addCardModal: addCardModalSelector(state),
  cards: cardsSelector(state),
  cardsList: cardsListSelector(state),
  user: userSelector(state),
  payer: payerSelector(state)
});

export default connect(
  mapStateToProps,
  {
    addCard,
    deleteCard,
    setModal
  }
)(CardScreen);
